export const chartType = {
    bar: {
        code: 1,
        label: 'bar'
    },
    pie: {
        label: 'pie',
        code: 2
    }
}

export const sortDataType = {
    valueasc: 1,
    valuedesc: 2,
    labelasc: 3,
    labeldesc: 4
}

export const barSize = {
    Thinnest: {
        id: 1,
        name: 'thinnest',
        value: 0.2
    },
    Thin: {
        id: 2,
        name: 'thin',
        value: 0.4
    },
    Medium: {
        id: 3,
        name: 'medium',
        value: 0.6
    },
    Wide: {
        id: 4,
        name: 'wide',
        value: 0.8
    },
    Widest: {
        id: 5,
        name: 'widest',
        value: 1
    }
}

export const barDirection = {
    vertical: 1,
    horizontal: 2
}

export const pieInnerRadius = {
    none: {
        id: 1,
        value: 0
    },
    small: {
        id: 2,
        value: 40
    },
    medium: {
        id: 3,
        value: 60
    },
    big: {
        id: 4,
        value: 80
    }
}

export const pieLegendPosition = {
    hide: 0,
    top: 1,
    bottom: 2,
    right: 3,
    left: 4
}
